module.exports = __webpack_public_path__ + "img/img1.38f4ea9f.png";